<article class="w-full" style="height: 100dvh;">
  <section class="w-full h-full">
    <section class="w-full h-full fadein animation-duration-500 bg-cover bg-center ci-main-padding relative flex flex-column justify-content-end"
      style="background: url({{data.assets.backgroundUrl}});">
      <section class="z-4 relative">
        <h3 class="fadeindown animation-duration-500 text-4xl md:text-7xl font-normal ci-txt--white mb-3 md:mb-4">
          <span *ngIf="!typedMessage">
            {{ data.name }}
          </span>

          <ngx-typed-js *ngIf="typedMessage" [strings]="data.typedArray" [typeSpeed]="100" [backSpeed]="100"
            [loop]="true">
            <span class="typing"></span>
          </ngx-typed-js>
        </h3>

        <section class="w-full flex justify-content-center mb-3 fadeindown animation-duration-500"
          (click)="scrollToFeatureSection('mapHome')">
          <i
            class="bi bi-chevron-double-down ci-txt--white text-3xl md:text-4xl ci-project-banner__arrow-down cursor-pointer">
          </i>
        </section>
      </section>

      <section class="w-full h-full bg-black-alpha-40 absolute top-0 right-0 left-0 bottom-0 z-3"></section>

      <section *ngIf="data?.assets?.videoUrl && data?.gallery?.lenght > 0"
        class="w-full h-full absolute top-0 right-0 left-0 bottom-0 z-2">
        <article
          class="w-full h-full fadein animation-duration-500 video-container absolute top-0 right-0 left-0 bottom-0">
          <video autoplay muted loop playsinline id="background-video" class="background-video">
            <source [src]='safeUrl' type="video/mp4">
          </video>
        </article>
      </section>

      <section *ngIf="data?.gallery" class="w-full h-full absolute top-0 right-0 left-0 bottom-0 z-2">
        <swiper-container class="w-full h-full" autoplay-delay="7000">
          <swiper-slide class="w-full h-full" *ngFor="let link of data?.gallery">
            <section class="w-full h-full animation-duration-500 bg-cover bg-center" style="background: url({{link}});">
            </section>
          </swiper-slide>
        </swiper-container>
      </section>
    </section>
  </section>
</article>

<style>
  .video-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
  }

  .background-video {
    position: absolute;
    top: 50%;
    left: 50%;
    width: auto;
    height: auto;
    min-width: 100%;
    min-height: 100%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }
</style>